import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import { Message } from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
import './assets/index.css'
import axios from "axios";
import Vant from 'vant';
import 'vant/lib/index.css';
// import lang from 'element-ui/lib/locale/lang/en'
// import locale from 'element-ui/lib/locale'
// locale.use(lang)
Vue.use(ElementUI);
Vue.use(Vant);

// axios.defaults.baseURL = "http://47.243.170.250:8095"
// axios.defaults.baseURL = "http://10.3.51.209:8095/cgm_config_medicine_api_web"
axios.defaults.baseURL = "https://medicine.cgmgroup.jp/config-medicine-fe-api"
Vue.prototype.axios = axios;

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

const ua = navigator.userAgent.toLowerCase();
store.commit("setMobile", /phone|mobile|android|iphone|ipad|ipod/i.test(ua));

axios.interceptors.request.use((config) => {
  if (config.url != "/login" && config.url != "/register" && config.url != "/cgmPackage/list" && config.url != "/cgmSpu/getByPackageId" && config.url != "/smsRegister") {
    if (store.state.cgmUserVO) {
      config.headers["Authorization"] = "Bearer " + JSON.parse(store.state.cgmUserVO).token;
    }
    // else {
    //   router.push({ path: "/login" });
    //   Message({
    //     type: "error",
    //     message: "请登录！",
    //   });
    // }
  }
  return config;
}, (error) => {
  return Promise.reject(error);
});

axios.interceptors.response.use((res) => {
  if (res.data.code == 3) {// token过期
    store.commit("setCgmUserVO", null);
    router.push({ path: "/login" });
    Message({
      type: "error",
      message: res.data.msg,
    });
  } else if (res.data.code != 200) {
    Message({
      type: "error",
      message: res.data.msg,
    });
  }
  return res;
}, (error) => {
  return Promise.reject(error);
});
